<template>
  <div>
    <modal-edit-receive-method @refetch-data="refetchData" :isEdit="isEdit" :financeData="receiveMethodData" />
    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center mb-1 mb-sm-0 ">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <font-awesome-icon class="mr-50" icon="fa-solid fa-credit-card" />
            付款方式資料
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
         <div class="d-flex mobile-w100 flex-wrap mt-1 mt-lg-0">
            <b-form-input
              v-model="searchQuery"
              class="search-form mb-1 mb-sm-0 mr-sm-1"
              placeholder="搜尋"
            />

            <b-button class="mobile-w100"  @click="handleReceiveMethod()"
            v-if="ability.can('create', 'settings_finance_receive_methods')"
          >
              <feather-icon
                class="mr-1"
                icon="plusIcon"
                size="18"
              ></feather-icon
              >新增付款方式</b-button
            >
          </div>
      
      </div>
    </b-card>

    <b-card class="mb-0">
      <!-- Table Top -->
      <b-row>
        <!-- Table -->
        <b-col cols="12">
          <b-table
            ref="refReceiveMethodListTable"
            class="position-relative"
            :items="fetchReceiveMethods"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="沒有匹配的數據"
            :sort-desc.sync="isSortDirDesc"
          >
            <template #cell(actions)="data">
              <b-dropdown
                variant="link"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item @click="handleReceiveMethod(data.item)" v-if="ability.can('update', 'settings_finance_receive_methods')">
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">編輯</span>
                </b-dropdown-item>

                <b-dropdown-item @click="removeItem(data.item.id)" v-if="ability.can('delete', 'settings_finance_receive_methods')">
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">刪除</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <!-- Table Pagination -->
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted"
            >顯示 {{ dataMeta.from }} 到 {{ dataMeta.to }} 共 {{ dataMeta.of }} 條目</span
          >
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRow"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useReceiveMethodsList from "./useReceiveMethodsList";
import financeStatusStoreModule from "../../financeStatusStoreModule";
import ModalEditReceiveMethod from "../modal/ModalEditReceiveMethod.vue";
export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ModalEditReceiveMethod,
  },
  data() {
    return {
      receiveMethodData: {id:0,sort_order:0, name: ''},
      isEdit: false,
    };
  },
  methods: {
    handleReceiveMethod(item) {
      if(item){
        this.receiveMethodData = item;
        this.isEdit = true;
      }else{
        this.receiveMethodData = {id:0,sort_order:0, name: ''};
        this.isEdit = false;
      }
      this.$bvModal.show('modal-edit-receive-method')
    },
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          store
            .dispatch("receiveMethod/deleteReceiveMethod", { id: id })
            .then((response) => {
              this.$swal({
                icon: "success",
                title: "刪除!",
                text: "付款方式已被刪除。",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.refetchData();
            })
            .catch((error) => {
              if (error.response.status === 409) {
                this.$swal({
                  icon: "error",
                  title: "無法刪除!",
                  text: error.response.data.message,
                  customClass: {
                    confirmButton: "btn btn-danger",
                  },
                });
              } else {
                this.$swal({
                  icon: "error",
                  title: "刪除失敗!",
                  text: "刪除付款方式時發生錯誤。",
                  customClass: {
                    confirmButton: "btn btn-danger",
                  },
                });
              }
            });
        }
      });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "receiveMethod";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, financeStatusStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const {
    fetchReceiveMethods,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    receiveMethodsList,
    refReceiveMethodListTable,
    ability,
    refetchData,
    } = useReceiveMethodsList();

    return {
    fetchReceiveMethods,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    receiveMethodsList,
    refReceiveMethodListTable,
    ability,
    refetchData,
    };
  },
};
</script>
  
<style lang="scss">

</style>
